import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      width: 57,
      height: 54,
      margin: [-4, 0, 0, -2],
    },
  },
  {
    name: 'Mfa',
  },
);
